import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["contactFields", "destroy"]

  connect() {
    this.toggleContactFields();
  }

  toggleContactFields() {
    const select = this.element.querySelector("[data-main-contact-relation]");
    if (!select) return;

    const isInsured = select.value === "";
    if (isInsured) {
      this.contactFieldsTarget.classList.add("hidden");
    } else {
      this.contactFieldsTarget.classList.remove("hidden");
    }

    this.toggleOtherRelationField(select.value);
  }

  toggleOtherRelationField(value) {
    const otherField = this.element.querySelector("#other-relation-field");
    if (!otherField) return;

    if (value === "other") {
      otherField.classList.remove("hidden");
    } else {
      otherField.classList.add("hidden");
    }
  }

  onRelationChange(event) {
    const wasHidden = this.contactFieldsTarget.classList.contains("hidden");
    this.toggleContactFields();
    this.syncDestroyField();

    // Transitioning from "Insured (same person)" → non-insured: clear all
    // input values so the admin starts with blank fields for the new contact.
    const isNowVisible = !this.contactFieldsTarget.classList.contains("hidden");
    if (wasHidden && isNowVisible) {
      this.clearContactFields();
    }
  }

  syncDestroyField() {
    if (!this.hasDestroyTarget) return;

    const select = this.element.querySelector("[data-main-contact-relation]");
    this.destroyTarget.value = select.value === "" ? "1" : "0";
  }

  clearContactFields() {
    this.contactFieldsTarget
      .querySelectorAll("input[type=text], input[type=email], input[type=tel]")
      .forEach((input) => { input.value = ""; });
  }
}
